{
  "title": "Metadata",
  "labels": {
    "properties": "Eiendommer",
    "tags": "Etiketter",
    "byline": "Byline",
    "actions": "Handlinger",
    "otherSources": "Eksterne kilder",
    "origin": "Skapt fra",
    "source": "Kilde",
    "extraInformation": "Tilleggsinformasjon",
    "history": "Historikk",
    "editorialInfoType": "Redaksjonell informasjon, type",
    "slugline": "Stikkord",
    "category": "Kategori"
  },
  "actions": {
    "addNote": "Legg til beskjed",
    "convertToArticle": "Planlegg som artikkel",
    "convertToTimeless": "Lagre som tidløs",
    "removeHastFromArticle": "Fjern HAST fra artikkelen",
    "removeHastFromTimeless": "Fjern HAST fra tidløs"
  },
  "convertToArticle": {
    "descriptionWithPlanning": "En ny plan opprettes fra den opprinnelige. Velg dato for den nye artikkelen. Den tidløse artikkelen er fortsatt tilgjengelig.",
    "descriptionNoPlanning": "Velg dato for den nye artikkelen. Den tidløse artikkelen er fortsatt tilgjengelig.",
    "loadingPlanning": "Leter etter den opprinnelige planen…",
    "targetDateLabel": "Dato",
    "converting": "Lagrer…",
    "failed": "Kunne ikke opprette det nye dokumentet. Prøv igjen eller avbryt.",
    "noPlanningHint": "Ingen opprinnelig plan ble funnet — en ny plan opprettes fra den tidløse."
  },
  "convertToTimeless": {
    "description": "Velg kategori for den nye tidløse artikkelen. Den opprinnelige artikkelen er fortsatt tilgjengelig.",
    "publishedDisabled": "Publiserte artikler kan ikke lagres som tidløse."
  },
  "removeHastPrompt": {
    "title": "Fjern HAST fra artikkelen",
    "description": "Dette fjerner HAST og gjør den til en vanlig artikkel. Fremtidige versjoner sendes ikke som HAST med mindre du aktiverer det igjen.",
    "confirm": "Fjern"
  },
  "removeHastPromptTimeless": {
    "title": "Fjern HAST fra tidløs",
    "description": "Dette fjerner HAST og gjør den til en vanlig tidløs. Fremtidige versjoner sendes ikke som HAST med mindre du aktiverer det igjen."
  },
  "bylineCredit": {
    "creditOrganisation": "Publiser under {{organisation}}",
    "creditAuthors": "Publiser under forfatterne",
    "authorsHint": "Vises ikke i bylinen"
  },
  "placeholders": {
    "addByline": "Legg til byline",
    "addSource": "Legg til kilde"
  },
  "dropDownMenuItems": {
    "internalNote": "Intern beskjed",
    "infoToCustomer": "PRIV"
  },
  "misc": {
    "noType": "Ingen type",
    "noByline": "Ingen byline",
    "noSource": "Ingen kilde"
  }
}